import ScrollTrigger from "gsap/ScrollTrigger";

import TileDialog from '../components/tileDialog';

class ResponsiveSlider {
  constructor($el) {
    this.$el = $el;
    this.$slider = this.$el.find('[data-responsive-slider="slider"]');
    this.$nav = this.$el.find('[data-responsive-slider="nav"]');
    this.$next = this.$nav.find('[data-responsive-slider="next"]');
    this.$prev = this.$nav.find('[data-responsive-slider="prev"]');
    this.$tiles = this.$el.find('[data-tile-dialog="el"]');
    this.tiles = [];
    this.init();
  }

  init = () => {
    import("slick-carousel").then(() => {
      this.slick = this.$slider.slick({
        infinite: false,
        speed: 500,
        dots: false,
        autoplay: false,
        fade: false,
        slidesToShow: 3,
        arrows: false,
        swipe: true,
        responsive: [
          {
						breakpoint: 1024,
						settings: {
							slidesToShow: 2,
							slidesToScroll: 1,
						},
					},
          {
						breakpoint: 768,
						settings: {
							slidesToShow: 1.2,
							slidesToScroll: 1,
						},
					},
        ]
      });

      this.sliderAfterChangeHandler();

      this.$next.on('click', () => {
        this.$slider.slick('slickNext');
      });

      this.$prev.on('click', () => {
        this.$slider.slick('slickPrev');
      });

      // init tile dialog
      if(this.$tiles.length) {
        this.slick.on('breakpoint', this.initTileDialog);
        this.initTileDialog();
      }


      this.slick.on('afterChange', this.sliderAfterChangeHandler);
      this.slick.on('beforeChange', this.sliderBeforeChangeHandler);

      ScrollTrigger.refresh();
    });
  }

  sliderAfterChangeHandler = () => {
    let { slick } = this.slick[0];

    let slidesToShow = slick.activeBreakpoint ? slick.breakpointSettings[slick.activeBreakpoint].slidesToShow : 3;
    let index = slick.currentSlide;
    let slideCount = slick.slideCount;

    if (slidesToShow >= slideCount) {
      this.$nav.removeClass('d-md-flex');
    } else {
      this.$nav.addClass('d-md-flex');
    }

    if (index === 0) {
      this.$prev.prop('disabled', true);
    } else {
      this.$prev.prop('disabled', false);
    }

    if (index + slidesToShow >= slideCount) {
      this.$next.prop('disabled', true);
    } else {
      this.$next.prop('disabled', false);
    }

    if(this.tiles.length) {
      this.tiles.forEach((tile) => {
        tile.setSliding(false);
      });
    }
  }

  sliderBeforeChangeHandler = () => {
    if(this.tiles.length) {
      this.tiles.forEach((tile) => {
        tile.setSliding(true);
      });
    }
  }

  initTileDialog = () => {
    this.tiles.forEach((tile) => {
      tile.destroy();
    });

    this.tiles = [];

    this.$tiles.each((index, el) => {
      const $tile = $(el);
      const target = $tile.data('dialog-id');
      const $dialog = $(`[data-id="${target}"]`);

      this.tiles.push(new TileDialog($tile, $dialog));
    });
  }
}

export default ResponsiveSlider;